module.exports = __webpack_public_path__ + "static/img/kefuImg1.74c5ce78.png";